// extracted by mini-css-extract-plugin
export default {"my_card_box":"MenuMyCard_my_card_box__99dsG","open":"MenuMyCard_open__BhMYL","close":"MenuMyCard_close__fKBwd"};